import { type RootState } from '../../stores/redux';
import { type ScreenshareState } from './screenshare.types';

export const getScreenshareState = (state: RootState) =>
  state.screenshare.screenshareState as ScreenshareState;

export const getCurrentRequestedMember = (state: RootState) =>
  state.screenshare.currentRequestedMemberId;

export const getScreenshareEventData = (state: RootState) =>
  state.screenshare.currentEventData;

export const getScreenshareStartedTime = (state: RootState) =>
  state.screenshare.startedAt;
